/**
 * PaymentSuccess - Page de succès générique
 * Redirige vers PaymentSuccessPage unifié
 */
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const type = searchParams.get('type') || 'default';

  useEffect(() => {
    // Rediriger vers la page de succès unifiée
    if (sessionId) {
      navigate(`/paiement/success?session_id=${sessionId}&type=${type}`, { replace: true });
    } else {
      navigate('/member/dashboard', { replace: true });
    }
  }, [sessionId, type, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-blue-500 animate-spin mx-auto mb-4" />
        <p className="text-gray-600">Redirection...</p>
      </div>
    </div>
  );
}
